module.exports = __webpack_public_path__ + "img/square-t.e0aed36f.svg";